import { FC } from "react";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../../redux/slices";

const Annotation: FC = () => {
  const [t] = useTranslation("global");
  const { sampleViewInfo } = useSelector(
    (state: State) => state.DataSampleViewReducer,
  );

  const labels = sampleViewInfo?.labels;
  const textsResults = sampleViewInfo?.texts;
  const finalAnnotations = labels
    ? Object.keys(labels).map((key) => {
        const labelData = labels[key];
        const displayName = textsResults?.[key] || key;
        return {
          key: key,
          name: displayName,
          data: labelData,
        };
      })
    : [];
  const annotationContent = finalAnnotations?.map((labelInstances) => {
    return (
      <div
        className="feat-content-annotation"
        key={`name-${labelInstances.key}`}
      >
        {labelInstances.name}
      </div>
    );
  });

  const annotationValues = finalAnnotations?.map((labelInstances) => {
    return (
      <div
        className="feat-content-annotation-value"
        key={`value-${labelInstances.key}`}
      >
        {labelInstances.data}
      </div>
    );
  });

  return (
    <div className="annotations">
      <div className="title-sections-sample-view">
        {t("Data.table.AnnotationName")}
      </div>
      <div className="annotation-container">
        <div key={""} className="annotations-result">
          <div className="annotations-result-values">
            <div className="result-annotation-1">
              {finalAnnotations && finalAnnotations?.length >= 1
                ? annotationContent
                : ""}
            </div>
            <div className="result-annotation-2">
              {finalAnnotations && finalAnnotations?.length >= 1
                ? annotationValues
                : ""}
            </div>
          </div>

          {finalAnnotations?.length === 0 ? (
            <Alert severity="warning">
              {t("Data.SampleView.No_annotations")}
            </Alert>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Annotation;
